const { REACT_APP_ROOT, REACT_APP_APIURL } = process.env;

// eslint-disable-next-line import/no-default-export
export default {
  REACT_APP_ROOT: REACT_APP_ROOT || '',
  REACT_APP_APIURL: REACT_APP_APIURL || 'Proxy',
  MOCK_SERVER: 'http://localhost:3030'
};
